import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { PagePath } from 'root-constants'
import { selectCurrentVariantCohort } from 'root-redux/selects/common'
import { googleAnalyticsLogger } from 'services/googleAnalytics.service'
import { useLocation } from 'react-router'

export const useGAPageTracker = (): void => {
  const { pathname } = useLocation()
  const cohort = useSelector(selectCurrentVariantCohort)

  useEffect(() => {
    const currentOnboardingVariant = cohort ? `/${cohort}` : ``

    if (window.location.href.includes(PagePath.LOCALHOST)) return

    const currentLocation = `${pathname}${currentOnboardingVariant}`
    googleAnalyticsLogger.logPageView(currentLocation)
  }, [pathname, cohort])
}
